module.exports = __webpack_public_path__ + "img/desert_camel_store.c321e5d6.png";